import { CalendarDays, Megaphone, Sparkles, Users } from "lucide-react";

/**
 * Coach Chalkboard "Quick Draw" 2x2 grid: shortcuts to Playbook, Chalk Talk,
 * Roster, and Draw It Up (or Upgrade for non-Chalkboard tiers).
 */
export function QuickDrawGrid({ isChalkboard, onPlay, onTalk, onRoster, onAi }) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
      <QuickTile icon={<CalendarDays size={18} />} label="Add a play" onClick={onPlay} testId="qd-play" />
      <QuickTile icon={<Megaphone size={18} />} label="Chalk Talk" onClick={onTalk} testId="qd-talk" />
      <QuickTile icon={<Users size={18} />} label="Roster" onClick={onRoster} testId="qd-roster" />
      <QuickTile
        icon={<Sparkles size={18} />}
        label={isChalkboard ? "Draw It Up" : "Upgrade"}
        onClick={onAi}
        testId="qd-ai"
      />
    </div>
  );
}

function QuickTile({ icon, label, onClick, testId }) {
  return (
    <button
      data-testid={testId}
      onClick={onClick}
      style={{
        textAlign: "left", padding: 16, borderRadius: 14,
        background: "#fff", border: "0.5px solid var(--chalk-border)",
        cursor: "pointer", display: "flex", flexDirection: "column", gap: 14,
        transition: "transform 120ms ease", color: "var(--chalk-board)",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-1px)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
    >
      <span style={{ color: "var(--chalk-green)" }}>{icon}</span>
      <span style={{ fontSize: 14, fontWeight: 500 }}>{label}</span>
    </button>
  );
}
